const rotation = {
  left: 0,
  up: 90,
  right: 180,
  down: 270,
};

type Props = {
  direction?: "left" | "right" | "up" | "down";
  size?: number;
};

const Caret = ({ direction = "left", size = 16 }: Props) => {
  const halfSize = size * 0.5;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
    >
      <path
        transform={`rotate(${rotation[direction]}, ${halfSize}, ${halfSize})`}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 2 4 8l7 6"
      />
    </svg>
  );
};

export default Caret;
